
    import {Component, Mixins} from 'vue-property-decorator'
    import EditField from '@/components/Base/EditField.vue'
    import ServiceAuthButtons from '@/pages/Login/ServiceAuthButtons.vue'
    import Delimiter from '@/components/Base/Delimiter.vue'
    import CheckPassword from '@/pages/Login/CheckPassword.vue'
    import Requester from '@/requester/Requester'
    import request from 'axios'
    import {AdaptiveMixin} from '@/mixins/AdaptiveMixin'
    import IAuthUser from '@/typings/IAuthUser'
    import {store} from '@/store'

    @Component({
        components: {
            ServiceAuthButtons,
            EditField,
            Delimiter,
            CheckPassword,
        }
    })
    export default class LoginOptionsWrapper extends Mixins<AdaptiveMixin>(AdaptiveMixin) {
        email = ''
        password = ''
        currentErrorMessage = ''

        loading = false

        redirectToRegistration() {
            this.$router.push({name: 'registration'})
        }

        redirectToPasswordRecovery() {
            this.$router.push({name: 'password-recovery'})
        }

        async signIn() {
            this.currentErrorMessage = ''
            this.loading = true

            const res = await Requester.auth(this.email, this.password)

            if (res.type === 'error') {
                if (request.isAxiosError(res.response) && res.response.response) {
                    this.currentErrorMessage = (res.response.response?.data as {message: string}).message
                }
            } else {
                const user: IAuthUser = res.response.data

                store.commit('auth/setUser', user)
                if (user && user.access_token) {
                    await this.$router.push({name: 'chat'})
                } else {
                    await this.$router.push({name: 'confirm-account'})
                }
            }

            this.loading = false
        }
    }
